import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageES() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Análisis de Relaciones con IA | Detecta Patrones Tóxicos y Gaslighting" description="Averigüe si su ex es el problema. Suba sus chats a la IA de ToxicDetector para un análisis instantáneo y confidencial de manipulación, gaslighting y señales de alerta. Comience el escaneo gratuito hoy." keywords="análisis de relaciones con IA, detectar patrones tóxicos, detector de gaslighting, ex tóxico, verificador de manipulación, toxicidad en relaciones, escáner de texto con IA" canonical="https://toxicdetector.com/es" language="es-MX" alternateUrls={alternateUrls} data-id="element-5374" />
      <GoogleTranslateWidget data-id="element-5375" />
      <PromoBanner data-id="element-5376" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5377">
        <Header data-id="element-5378" />
        <main data-id="element-5379">
          <HeroSection h1Override={<>
                Tu Cerebro Te{' '}
                <span className="relative inline-block" data-id="element-5381">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-5382">
                    Miente
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-5383" />
                </span>
                {'. '}
                <br data-id="element-5384" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-5385">
                  Nuestra IA No.
                </span>
              </>} data-id="element-5380" />
          <TrustSection data-id="element-5386" />
          <FeaturesSection data-id="element-5387" />
          <GuaranteesSection data-id="element-5388" />
          <ToolsSection data-id="element-5389" />
          <ComparisonSection data-id="element-5390" />
          <PricingSection data-id="element-5391" />
          <FAQSection data-id="element-5392" />
          <CTASection data-id="element-5393" />
        </main>
        <Footer data-id="element-5394" />
      </div>
    </>;
}